export default __webpack_public_path__ + "static/media/example_csv_before.0a025258.png";